import {
  CreateChallengeOperationRequest,
  CreateChallengeRequest,
  CreateChallengeResponse,
  UpdateChallengeCoverRequest,
} from "@revolutionrobotics/admin-api";
import React, { useState, useContext } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { ChallengeApi } from "../../services/configuration";
import { SetError } from "../../services/general";
import { ButtonWithStyle } from "../ButtonWithStyle";
import { LanguageSelector } from "../Language/LanguageSelector";
import LanguageContext from "../../services/LanguageContext";
import { FormItem } from "../FormItem";

interface NewChallengeFormProps {
  insertAfterId?: string;
  categoryId: string;
  setError: Function;
  refresh: Function;
}

export function NewChallengeForm({
  insertAfterId,
  categoryId,
  setError,
  refresh,
}: NewChallengeFormProps) {
  const [validated, setValidated] = useState(false);
  const [inputs, setInputs] = useState<any | null>(null);
  const [file, setFile] = useState<File | null>(null);
  const { language } = useContext(LanguageContext);

  const handleSubmit = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
    setValidated(true);

    if (!inputs || !inputs.title || !inputs.description) return;

    const details: CreateChallengeRequest = {
      lang: language,
      title: inputs.title,
      description: inputs.description,
      categoryId: categoryId,
    };

    const req: CreateChallengeOperationRequest = {
      request: details,
      insertAfterID: insertAfterId || undefined,
    };

    ChallengeApi.createChallenge(req)
      .then(
        (response: CreateChallengeResponse) => {
          console.log(response.id, "has been created.");
          updateImage(response.id);
        },
        (error) => {
          SetError(error, setError);
        }
      )
      .finally(() => {
        refresh();
      });
  };
  const updateImage = (id: string) => {
    console.log("uploadChallengeImage()", file?.name, id);

    if (!file || !id) {
      refresh();
      return;
    }

    const req: UpdateChallengeCoverRequest = {
      id: id,
      file: file,
    };

    ChallengeApi.updateChallengeCover(req)
      .then(
        () => {
          console.log(id, "challenge image has been updated.");
        },
        (error) => {
          SetError(error, setError);
        }
      )
      .finally(() => {
        setFile(null);
        refresh();
      });
  };

  const handleFileUpload = (event: any) => {
    if (event.target && event.target.files && event.target.files?.length > 0) {
      setFile(event.target.files[0]);
    } else {
      setFile(null);
    }
  };

  const handleChange = (event: any) => {
    if (event.target.name === "file") {
      handleFileUpload(event);
    }
    const name = event.target.name;
    const value = event.target.value;
    setInputs((values: any) => ({ ...values, [name]: value }));
  };

  return (
    <Form noValidate validated={validated} onSubmit={handleSubmit}>
      <Row className="mb-3">
        <Col>
          <Row className="mb-3">
            <Form.Label>Language</Form.Label>
            <LanguageSelector />
          </Row>
          <Row>
            <FormItem
              title={"Title"}
              type={"text"}
              required={true}
              name={"title"}
              handleChange={handleChange}
            />
          </Row>
          <Row className="mt-2">
            <FormItem
              title={"Description"}
              type={"text"}
              required={true}
              name={"description"}
              handleChange={handleChange}
              isTextArea={true}
            />
          </Row>
          <Row>
            <FormItem
              title={"Cover"}
              type={"file"}
              required={true}
              name={"file"}
              handleChange={handleChange}
              fileAccept="image/jpeg"
            />
          </Row>
        </Col>
      </Row>

      <ButtonWithStyle buttonTitle="Create" type="submit" variant="primary" />
    </Form>
  );
}
